// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import MenuItem from './MenuItem';

/**
 * `MenuSelectableItem` component.
 */
const MenuSelectableItem = ({ baseClassName, className, children, selected, ...props }) => (
    <MenuItem
        className={classNames(baseClassName, className)}
        icon={selected ? 'check-mark' : null}
        {...props}
    >
        {children}
    </MenuItem>
);

MenuSelectableItem.propTypes = {
    /**
     * Whether item is selected.
     */
    selected: PropTypes.bool,
    /**
     * Content of the `MenuSelectableItem`.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

MenuSelectableItem.defaultProps = {
    selected: false,
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}menu__item`,
};

export default MenuSelectableItem;



// WEBPACK FOOTER //
// ./components/Menu/MenuSelectableItem.js